import { MatchedPaymentRegisterItemWithBankDetails } from "../payments/types";

function Table<T extends {}>(props: {
  data: T[];
  tableHeaderData: Array<keyof T>;
  includeCount?: boolean;
}) {
  const { data, tableHeaderData, includeCount = false } = props;
  const tableRows: T[keyof T][][] = data.map((dataRow: T) => {
    return tableHeaderData.map((headerColumn: keyof T) => {
      return dataRow[headerColumn];
    });
  });
  return (
    <section>
      <table>
        <thead>
          <tr>
            {includeCount && <th>#</th>}
            {tableHeaderData.map((headerColumn: keyof T, index: number) => {
              return <th key={index}>{String(headerColumn)}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {tableRows.map((tableRow: T[keyof T][], rowIndex: number) => {
            return (
              <tr key={rowIndex}>
                {includeCount && <td>{rowIndex + 1}</td>}

                {tableRow.map(
                  (tableColumn: T[keyof T], columnIndex: number) => {
                    return (
                      <td key={columnIndex}>{String(tableColumn ?? "")}</td>
                    );
                  }
                )}
              </tr>
            );
          })}
        </tbody>
        <tfoot></tfoot>
      </table>
    </section>
  );
}
export { Table };
